module.exports = __webpack_public_path__ + "img/hk.cd10a663.jpg";